import 'normalize.css';
/* google-roboto подключается отдельным <link> в .content.twig — не ждём парсинга app.css */
import '../fonts/ks-icons/ksi.css';
import '../c/variables.css';
import '../c/main.css';
import '../c/table.css';
import '../c/preloader.css';
import 'font-awesome/css/font-awesome.min.css';
import './font-awesome-display.css';
import '../c/social-links-font.css';
import '../c/landing-base.css';
import "../c/pages/common.css";
import "../c/pages/contacts.css";
import "../c/pages/qualification.css";
import "../c/pages/partner.css";
import "../c/pages/api-changelog.css"
import "../c/pages/dashboard.keyword.css";
import "../c/pages/demo.css";
import "../c/_partial/footer.css";
import "../c/system.css";

import { createApp, defineAsyncComponent } from 'vue';
import { store } from './store';
import { i18n } from "./plugins/i18n";
import { emitter } from './plugins/emitter';
import upload from "./plugins/upload";
import router from "./plugins/router";
import PrimeVue from './plugins/prime-vue';
import VueJsTour from '@globalhive/vuejs-tour';
import '@globalhive/vuejs-tour/dist/style.css';
import Popper from "vue3-popper";
import Vue3MobileDetection from "vue3-mobile-detection";

import './bootstrap';
import snotify from 'vue3-snotify';
import "vue3-snotify/style";
import animateScrollTo from "animated-scroll-to";
import sprintf from 'sprintf-js';
import {RecycleScroller} from 'vue3-virtual-scroller';
import 'vue3-virtual-scroller/dist/vue3-virtual-scroller.css';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import config from "@appConfig";
import {Listeners} from "./constants/listeners";
import TariffPageQuestions from "./page/tariff/component/Questions.vue";
import CommonVideo from "./component/common/Video.vue";

import axios from 'axios';
axios.defaults.headers.common['Accept-Language'] = window.locale;
const debug = process.env.NODE_ENV !== 'production';
if (debug) {
    axios.interceptors.request.use((config) => {
        config.params = config.params ? config.params : {};
        Object.assign(config.params, {XDEBUG_SESSION_START: 'PHPDEBUG'});
        return config
    });
}

import BlockAdBlock from "./component/BlockAdBlock.vue";
import BlockBreadcrumbs from "./component/breadcrumbs/Breadcrumbs.vue";
import PartnerOffers from "./page/partner/PartnerOffers.vue";
import PartnerCookie from "./component/PartnerCookie.vue"
import UserLimit from './component/UserLimit.vue';
import PdfDashboard from './component/breadcrumbs/PdfDashboard.vue';
import YouTube from './page/report/component/YouTube.vue';
import YouTubeEmbed from "./component/YouTubeEmbed.vue";
import PaymentForm from "./page/bill/component/PaymentForm.vue";
import PaymentDelete from "./page/bill/component/PaymentDelete.vue";
import BillResultPage from "./page/billresult/Page.vue";
import Loader from "./component/Loader.vue";
import AdaptersLoader from "./component/adapters/Loader.vue";
import ReportWaiter from "./component/ReportWaiter.vue";
import LogoComponent from './component/Logo.vue';
import FaqComponent from "./component/Faq";
import SubscriptionComponent from './component/Subscription.vue';
import SelectTariff from './component/SelectTariff.vue';
import PromoSearchForm from './component/PromoSearchForm.vue';
import MenuTopSearch from "./component/menu/component/Search.vue";
import MenuTopSearchRobots from "./component/menu/component/SearchRobots.vue";
import BlockMainPartners from "./component/blocks/MainPartners.vue";
import BlockMainStart from "./component/blocks/MainStart.vue";
import ComparePageComponent from "./page/compare/Compare";
import CompareStartComponent from "./page/compare/CompareStart.vue";
import CompareDashSkips from "./page/compare/component/Skips.vue";
import ReportCompareComponent from "./page/compare/Keys";
import ReportPageComponent from './page/report/Report';
import TariffPageComponent from "./page/tariff/Page.vue";
import TariffLimitsPageComponent from "./page/tariff-limits/Page.vue";
import ReportAdsComponent from "./page/ads/Ads";
import ReportRsyAdsComponent from "./page/rsy/Ads";
import ReportAllRsyAdsComponent from './page/rsy/AllAds';
import ReportDirectAdsComponent from "./page/directads/Ads";
import ReportDirectAdKeysComponent from "./page/directads/AdKeys";
import ReportDirectAdDomainComponent from "./page/directads/Domain";
import ReportAdsFactsComponent from "./page/ads/AdsFacts";
import ReportAdsLinksComponent from "./page/ads/AdsLinks";
import ReportAdKeysComponent from "./page/adkeys/AdKeys";
import ZenChannelPublications from "./page/zen/ChannelPublications";
import ZenChannelNewTopPublications from "./page/zen/ChannelNewTopPublications";
import ReportAdKeysByAdsComponent from "./page/adkeysbyads/AdKeysByAds";
import AdsMonthSelector from "./page/ads/MonthSelector.vue";
import ReportAdsByKeywordComponent from "./page/adsbykeyword/AdsByKeyword";
import ReportAdConcurentsComponent from "./page/adconcurents/AdConcurents";
import ReportAdCompanyComponent from "./page/adcompany/AdCompany";
import ReportKeywordsComponent from "./page/keywords/Keywords";
import ReportKeysByPageComponent from "./page/keysbypage/KeysByPage";
import ReportKeysByLostPageComponent from "./page/keysbylostpage/KeysByLostPage";
import ReportLostKeywordsComponent from "./page/lostkeywords/LostKeywords";
import ReportAiAnswersComponent from "./page/aianswers/AiAnswers";
import ReportSitePagesComponent from "./page/sitepages/SitePages";
import ReportSiteWithKeysPagesComponent from "./page/sitepageswithkeys/SitePagesWithKeys";
import ReportConcurentsComponent from "./page/concurents/Concurents";
import ReportAiConcurentsComponent from "./page/aiconcurents/AiConcurents";
import ReportConcurentPagesComponent from "./page/concurentpages/ConcurentPages";
import ReportTreePagesComponent from "./page/treepages/TreePages";
import ReportSimilarKeysComponent from "./page/similarkeys/SimilarKeys";
import ReportSearchKeysComponent from "./page/searchkeys/SearchKeys";
import ReportVisDomainComponent from "./page/visdomain/Visdomain";
import ReportTopKeysComponent from "./page/topkeys/Topkeys";
import ZenViewsRatingTable from "./page/zenViewsRating/Page";
import ZenViewsTillEndRating from './page/zenViewsTillEndRating/Page';
import ZenAuditoryRating from './page/zenAuditoryRating/Page';
import ReportBacklinks from './page/backlinks/BackLinks';
import ReportBacklinksDomains from './page/backlinks/BackLinksDomains';
import ReportOutlinksDomains from './page/outlinks/OutlinksDomains';
import ReportBacklinksIp from './page/backlinks/BackLinksIp';
import ReportBacklinksIpSubnet from './page/backlinks/BackLinksIpSubnet';
import ReportBacklinksTopPages from "./page/backlinks/TopPages";
import ReportBacklinksAnchor from "./page/backlinks/BackLinksAnchor";
import ReportOutlinks from './page/outlinks/OutLinks';
import ReportSimilarKeywordsStart from "./page/similarkeys/Start.vue";
import ReportGroupDomainsComponent from "./page/group/domains/Domains";
import ReportGroupKeywordsComponent from "./page/group/keywords/Keywords";
import ReportGroupConcurentsComponent from "./page/group/concurents/Concurents";
import ReportGroupAdConcurentsComponent from "./page/group/adconcurents/AdConcurents";
import ReportGroupAdKeysComponent from './page/group/adkeys/AdKeys';
import ReportGroupAdsComponent from "./page/group/ads/Ads";
import ReportGroupAdsLinksComponent from "./page/group/ads/AdsLinks";
import ReportGroupAdsFactsComponent from "./page/group/ads/AdsFacts";
import ReportGroupSitePagesComponent from "./page/group/sitepages/SitePages";
import GroupReportTitle from "./page/group/component/ReportTitle.vue";
import ReportOwnerComponent from "./page/owner/Owner";
import ReportWordstatComponent from "./page/wordstat/Wordstat";
import WordstatReportTitle from "./page/wordstat/component/ReportTitle.vue";
import ZenChannelAllConcurrent from "./page/zen/ChannelAllConcurrent";
import ToolBox from "./component/common/ToolBox.vue";
import KsImg from "./component/common/KsImg.vue";
import SystemNotificationsTable from "./page/system-notifications/SystemNotificationsTable";
import AllRsyAdsContainer from "./component/rsy-ads/AllRsyAdsContainer.vue";
import UserVerify from "./component/UserVerify.vue";
import KSFilter from './component/ks-filter/KSFilter.vue'
import KSTable from "./component/ks-table/KSTable.vue";
import PositionHistoryComponent from './component/common/PositionHistoryComponent.vue';
import KSReportTour from "./page/report/component/KSReportTour.vue";
import RsyAdsPageAction from "./component/ks-table/component/rsy-ads-page-action.vue";
import KSClusterAction from "./page/clustering/component/KSClusterAction.vue";
import KSClusterEdit from "./page/clustering/component/KSClusterEdit.vue";
import KSClusterTour from "./page/clustering/component/KSClusterTour.vue";
import KSClusterPageWaiter from "./page/clustering/component/KSClusterPageWaiter.vue";
import KSSelect from './component/KSSelect.vue';
import KSGroupTableActions from "./page/group/component/KSGroupTableActions.vue";
import VennComponent from "./page/compare/component/VennComponent.vue";
import DomainAction from "./component/ks-table/component/domain-action.vue";
import CheckboxKeysAction from "./component/ks-table/component/checkbox-keys-action.vue";
import ConcPagesAction from "./component/ks-table/component/conc-pages-action.vue";
import LinksAction from "./component/ks-table/component/links-action.vue";
import KeywordsForOnlineWsParserAction from "./component/ks-table/component/keywords-for-online-ws-parser-action.vue";
import VuetablePaginationDropDown from "./component/vuetable-2/components/VuetablePaginationDropdown.vue";
import VuetablePaginationInfo from "./component/vuetable-2/components/VuetablePaginationInfo.vue";
import VuetablePagination from "./component/vuetable-2/components/VuetablePagination.vue";
import Vuetable from "./component/vuetable-2/components/Vuetable.vue";
import TreePagesMain from "./page/treepages/component/TreePagesMain.vue";
import TreeExport from "./page/treepages/component/TreeExport.vue";
import DoughnutSites from "./page/tools/concurentsByKeywords/DoughnutSites.vue";
import Prolong from "./component/Prolong.vue";
import ShowTourButton from "./component/breadcrumbs/ShowTourButton.vue";
import MassReportDashboard from "./component/breadcrumbs/MassReportDashboard.vue";
import HistoryQueries from "./page/history/Queries.vue";
import GroupStart from "./page/group/component/Start.vue";
import GroupKeywords from "./page/group/component/Keywords.vue";
import ClusteringStart from "./page/clustering/component/Start.vue";
import KsCreateGroup from "./page/group/component/KSCreateGroup.vue";
import KsCreateCluster from "./page/clustering/component/KSCreateCluster.vue";
import ShowMore from "./component/ShowMore.vue";
import AdCompanyExport from "./page/adcompany/component/AdCompanyExport.vue";
import ZenDashboardChannelTitle from "./page/zen/component/dashboard/ChannelTitle.vue";
import ZenDashboardPublications from "./page/zen/component/dashboard/Publications.vue";
import PageWaiterComponent from "./page/PageWaiter.vue";
import GroupDomainsAction from './component/ks-table/component/group-domains-action.vue'
import KsCreateFreeProjectDialog from "./component/common/KsCreateFreeProjectDialog.vue";
import ForgotPasswordPage from "./page/forgotpassword/Page.vue";
import ForgotPasswordRestorePage from "./page/forgotpassword/RestorePage.vue";
import QualificationPage from "./page/qualification/Page.vue";
import ReferalCalculatorEarnings from "./page/referal/CalculatorEarnings.vue";
import PartnerHistoryEarnings from "./page/partner/HistoryEarnings.vue";
import PartnerUserPromocode from "./page/partner/UserPromocode.vue";
import WordstatPopupWsGraph from "./page/wordstat/component/PopupWsGraph.vue";
import RobotsReportPage from "./page/robots/ReportPage.vue";
import RuTubeEmbed from "./component/RuTubeEmbed.vue";
import ScrollToTop from "./component/ScrollToTop.vue";
import MenuTop from "./component/menu/Top.vue";
import MenuTopLite from "./component/menu/TopLite.vue";
import MenuLeft from "./component/menu/Left.vue";
import TemplatesModeSelector from "./templates/ModeSelector.vue";
import SerpReportTitle from "./page/serp/component/ReportTitle.vue";
import ReportBase from "./component/ReportBase.vue";
import NotificationTool from "./component/NotificationTool.vue";

Number.prototype.formatMoney = function (c, d, t) {
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};
String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1)
};

window.db = JSON.parse(window.db);
window.report_db = window.report_db ? JSON.parse(window.report_db) : window.db;

const app = createApp({
    data() {
        return {
            input_search : null,
            isSimpleReportForm: true,
            isGroupReportForm: false,
            chooseDataBase: false,
            loading: false,
            loadingContent: false,
        }
    },
    delimiters: ['<%', '%>'],
    created() {
        // инициализация основных данных хранилища
        this.initMainDataStore();
        // инициализация слушателей событий
        this.initEventsListeners();
    },
    methods: {
        scrollToTop: function () {
            setTimeout(() => {
                animateScrollTo(document.querySelector('body'));
            }, 0);
        },
        doSearch: function (query) {
            this.input_search = query;
        },
        showTour(id) {
            this.$emitter.emit(id);
        },
        initMainDataStore() {
            // загрузка данных текущего пользователя
            this.$store.dispatch('GET_USER');
            // загрузка данных текущей БД
            this.$store.dispatch('GET_DATABASE');
        },
        initEventsListeners() {
            // отображение прелоадера на весь экран
            this.$emitter.on(Listeners.GLOBAL_PRELOADER_SHOW, () => {
                this.loading = true;
                let element = document.getElementsByTagName('body')[0];
                element.classList.add("modal-open");
            });
            // отключение отображения прелоадера на весь экран
            this.$emitter.on(Listeners.GLOBAL_PRELOADER_HIDE, () => {
                this.loading = false;
                let element = document.getElementsByTagName('body')[0];
                element.classList.remove("modal-open");
            });
            // прелоадер контента
            this.$emitter.on(Listeners.CONTENT_PRELOADER_SHOW, () => this.loadingContent = true);
            this.$emitter.on(Listeners.CONTENT_PRELOADER_HIDE, () => this.loadingContent = false);
            // перезагрузка данных текущего пользователя
            this.$emitter.on(Listeners.REFRESH_USER, () => this.$store.dispatch('GET_USER'));
        }
    },
    components: {
        'popup-events-subscribe-expires': defineAsyncComponent(() => import('./component/popup-events/SubscribeExpires.vue')),
        'compare-start': () => import('./page/compare/CompareStart.vue'),
        UserVerify,
        // twig-end
        NotificationTool,
        TemplatesModeSelector,
        'landing-video': CommonVideo,
        GroupDomainsAction,
        'sites-compare-limits': defineAsyncComponent(() => import("./component/breadcrumbs/SitesCompareLimits.vue")),
        'history-serp-limits': defineAsyncComponent(() => import("./component/breadcrumbs/HistorySerpLimits.vue")),
        'group-limits': defineAsyncComponent(() => import("./component/breadcrumbs/GroupLimits.vue")),
        'concurents-by-keywords-limits': defineAsyncComponent(() => import("./component/breadcrumbs/ConcurentsByKeywordsLimits.vue")),
        'site-themes-limit': defineAsyncComponent(() => import("./component/breadcrumbs/SiteThemesLimits.vue")),
        'similarkeys-limits': defineAsyncComponent(() => import("./component/breadcrumbs/SimilarkeysLimits.vue")),
        'keywords-by-pages-limits': defineAsyncComponent(() => import("./component/breadcrumbs/KeywordsByPagesLimits.vue")),
        'dictionary-by-pages-limits': defineAsyncComponent(() => import("./component/breadcrumbs/DictionaryByPagesLimits.vue")),
        'extended-keywords-limits': defineAsyncComponent(() => import("./component/breadcrumbs/ExtendedKeywordsLimits.vue")),
        'check-top-limits': defineAsyncComponent(() => import("./component/breadcrumbs/CheckTopLimits.vue")),
        'keywords-by-list-limits': defineAsyncComponent(() => import("./component/breadcrumbs/KeywordsByListLimits.vue")),
        'yandex-direct-limits': defineAsyncComponent(() => import("./component/breadcrumbs/YandexDirectLimits.vue")),
        'rsya-limits': defineAsyncComponent(() => import("./component/breadcrumbs/RsyaLimits.vue")),
        'rsya-ads-limits': defineAsyncComponent(() => import("./component/breadcrumbs/RsyaAdsLimits.vue")),
        'ads-limits': defineAsyncComponent(() => import("./component/breadcrumbs/AdsLimits.vue")),
        'adconcurents-limits': defineAsyncComponent(() => import("./component/breadcrumbs/AdconcurentsLimits.vue")),
        'ai-answers-limits': defineAsyncComponent(() => import("./component/breadcrumbs/AiAnswersLimits.vue")),
        'adkeys-limits': defineAsyncComponent(() => import("./component/breadcrumbs/AdkeysLimits.vue")),
        'sitepages-limits': defineAsyncComponent(() => import("./component/breadcrumbs/SitepagesLimits.vue")),
        'keywords-limits': defineAsyncComponent(() => import("./component/breadcrumbs/KeywordsLimits.vue")),
        'concurents-limits': defineAsyncComponent(() => import("./component/breadcrumbs/ConcurentsLimits.vue")),
        'backlinks-limits': defineAsyncComponent(() => import("./component/breadcrumbs/BacklinksLimits.vue")),
        'outlinks-limits': defineAsyncComponent(() => import("./component/breadcrumbs/OutlinksLimits.vue")),
        'backlinks-toppages-limits': defineAsyncComponent(() => import("./component/breadcrumbs/BacklinksToppagesLimits.vue")),
        'clustering-limits': defineAsyncComponent(() => import("./component/breadcrumbs/ClusteringLimits.vue")),
        'dashboard-limits': defineAsyncComponent(() => import("./component/breadcrumbs/DashboardLimits.vue")),
        'dashboard-keyword-limits': defineAsyncComponent(() => import("./component/breadcrumbs/DashboardKeywordLimits.vue")),
        'treepages-limits': defineAsyncComponent(() => import("./component/breadcrumbs/TreepagesLimits.vue")),
        'projects-limits': defineAsyncComponent(() => import("./component/breadcrumbs/ProjectsLimits.vue")),
        'suggest-limits': defineAsyncComponent(() => import("./component/breadcrumbs/SuggestLimits.vue")),
        'domains-batch-limits': defineAsyncComponent(() => import("./component/breadcrumbs/DomainsBatchLimits.vue")),
        'search-keys-limits': defineAsyncComponent(() => import("./component/breadcrumbs/SearchKeysLimits.vue")),
        'serp-limits': defineAsyncComponent(() => import("./component/breadcrumbs/SerpLimits.vue")),
        'wordstat-limits': defineAsyncComponent(() => import("./component/breadcrumbs/WordstatLimits.vue")),
        'domains-batch-by-links': defineAsyncComponent(() => import("./page/domainsBatchByLinks/DomainsBatchByLinks")),
        'report-lost-pages-component': defineAsyncComponent(() => import("./page/lostpages/LostPages")),
        'registration-component': defineAsyncComponent(() => import("./page/registration/Registration.vue")),
        'login-component': defineAsyncComponent(() => import("./page/login/Login.vue")),
        'dzen-dashboard-limits': defineAsyncComponent(() => import("./component/breadcrumbs/DzenDashboardLimits.vue")),
        'dzen-new-top-publications-limits': defineAsyncComponent(() => import("./component/breadcrumbs/DzenNewTopPublicationsLimits.vue")),
        'dzen-publications-limits': defineAsyncComponent(() => import("./component/breadcrumbs/DzenPublicationsLimits.vue")),
        'dictionary-ext-by-page-limit': defineAsyncComponent(() => import("./component/breadcrumbs/DictionaryExtByPagesLimit.vue")),
        'lost-keywords-limits': defineAsyncComponent(() => import("./component/breadcrumbs/LostKeywordsLimits.vue")),
        'lost-pages-limits': defineAsyncComponent(() => import("./component/breadcrumbs/LostPagesLimits.vue")),
        'backlinks-anchor-limits': defineAsyncComponent(() => import("./component/breadcrumbs/BacklinksAnchorLimits.vue")),
        'backlinks-ip-limits': defineAsyncComponent(() => import("./component/breadcrumbs/BacklinksIpLimits.vue")),
        'backlinks-domains-limits': defineAsyncComponent(() => import("./component/breadcrumbs/BacklinksDomainsLimits.vue")),
        'outlinks-domains-limits': defineAsyncComponent(() => import("./component/breadcrumbs/OutlinksDomainsLimits.vue")),
        'monitoring-limits': defineAsyncComponent(() => import("./component/breadcrumbs/MonitoringLimits.vue")),
        'yandex-id-token-process': defineAsyncComponent(() => import("./page/registration/YandexIdTokenProcess.vue")),
        'top-select': defineAsyncComponent(() => import("./component/select/TopSelect.vue")),
        MassReportDashboard,
        ShowTourButton,
        BlockAdBlock,
        BlockBreadcrumbs,
        PartnerOffers,
        PartnerCookie,
        UserLimit,
        PdfDashboard,
        YouTube,
        YouTubeEmbed,
        'bill-payment': defineAsyncComponent(() => import('./modules/BillPayment').then(({ BillPayment }) => BillPayment)),
        'bill-payment-legal-form': defineAsyncComponent(() => import('./modules/BillPayment').then(({ BillPaymentLegalForm }) => BillPaymentLegalForm)),
        'bill-payment-legal-success': defineAsyncComponent(() => import('./modules/BillPayment').then(({ BillPaymentLegalSuccess }) => BillPaymentLegalSuccess)),
        PaymentForm,
        PaymentDelete,
        BillResultPage,
        ReportWaiter,
        LogoComponent,
        FaqComponent,
        SubscriptionComponent,
        SelectTariff,
        PromoSearchForm,
        MenuTopSearch,
        MenuTopSearchRobots,
        BlockMainPartners,
        BlockMainStart,
        'demonstration-popup': defineAsyncComponent(() => import('./modules/Demonstration').then(({ DemonstrationPopup }) => DemonstrationPopup)),
        'demonstration-block': defineAsyncComponent(() => import('./modules/Demonstration').then(({ DemonstrationBlock }) => DemonstrationBlock)),
        ForgotPasswordPage,
        ForgotPasswordRestorePage,
        QualificationPage,
        RobotsReportPage,
        ComparePageComponent,
        CompareStartComponent,
        CompareDashSkips,
        ReportCompareComponent,
        ReportPageComponent,
        TariffPageComponent,
        TariffLimitsPageComponent,
        ReportAdsComponent,
        ReportRsyAdsComponent,
        ReportAllRsyAdsComponent,
        ReportDirectAdsComponent,
        ReportDirectAdKeysComponent,
        ReportDirectAdDomainComponent,
        ReportAdsFactsComponent,
        ReportAdsLinksComponent,
        ReportAdKeysComponent,
        ZenChannelPublications,
        ZenChannelNewTopPublications,
        ReportAdKeysByAdsComponent,
        AdsMonthSelector,
        ReportAdsByKeywordComponent,
        ReportAdConcurentsComponent,
        ReportAdCompanyComponent,
        ReportKeywordsComponent,
        ReportKeysByPageComponent,
        ReportKeysByLostPageComponent,
        ReportLostKeywordsComponent,
        ReportAiAnswersComponent,
        ReportSitePagesComponent,
        ReportSiteWithKeysPagesComponent,
        ReportConcurentsComponent,
        ReportAiConcurentsComponent,
        ReportConcurentPagesComponent,
        ReportTreePagesComponent,
        ReportSimilarKeysComponent,
        ReportSearchKeysComponent,
        ReportVisDomainComponent,
        ReportTopKeysComponent,
        ZenViewsRatingTable,
        ZenViewsTillEndRating,
        ZenAuditoryRating,
        ReportGroupDomainsComponent,
        ReportGroupKeywordsComponent,
        ReportGroupConcurentsComponent,
        ReportGroupAdConcurentsComponent,
        ReportGroupAdKeysComponent,
        ReportGroupAdsComponent,
        ReportGroupAdsLinksComponent,
        ReportGroupAdsFactsComponent,
        ReportGroupSitePagesComponent,
        GroupReportTitle,
        ReportOwnerComponent,
        ReportSimilarKeywordsStart,
        ReportWordstatComponent,
        PageWaiterComponent,
        ReportBase,

        'elama': defineAsyncComponent(() => import('./modules/Elama').then(({ Elama }) => Elama)),

        'clustering-edit-page-component': defineAsyncComponent(() => import('./modules/Cluster').then(({ ClusteringEditComponent }) => ClusteringEditComponent)),

        'ks-tools-compare': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsCompare}) => KSToolsCompare)),
        'ks-tools-combine': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsCombine}) => KSToolsCombine)),
        'ks-tools-unique': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsUnique}) => KSToolsUnique)),
        'ks-tools-delete-double': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsDeleteDouble}) => KSToolsDeleteDouble)),
        'ks-tools-extended-keywords': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsExtendedKeywords}) => KSToolsExtendedKeywords)),
        'ks-tools-suggest': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsSuggest}) => KSToolsSuggest)),
        'extended-keywords-component': defineAsyncComponent(() => import('./modules/Tools').then(({ExtendedKeywordsComponent}) => ExtendedKeywordsComponent)),
        'ks-tools-keywords-by-pages': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsKeywordsByPages}) => KSToolsKeywordsByPages)),
        'ks-tools-keywords-by-list': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsKeywordsByList}) => KSToolsKeywordsByList)),
        'keywords-by-pages-component': defineAsyncComponent(() => import('./modules/Tools').then(({KeywordsByPages}) => KeywordsByPages)),
        'keywords-by-list-component': defineAsyncComponent(() => import('./modules/Tools').then(({KeywordsByList}) => KeywordsByList)),
        'ks-tools-dictionary-ext-by-pages': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsDictionaryExtByPage}) => KSToolsDictionaryExtByPage)),
        'ks-tools-concurents-by-keywords': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsConcurentsByKeywords}) => KSToolsConcurentsByKeywords)),
        'concurents-by-keywords-component': defineAsyncComponent(() => import('./modules/Tools').then(({ConcurentsByKeywords}) => ConcurentsByKeywords)),
        'ks-tools-dictionary-by-pages': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsDictionaryByPages}) => KSToolsDictionaryByPages)),
        'ks-tools-domains-batch': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsDomainsBatch}) => KSToolsDomainsBatch)),
        'domains-batch-component': defineAsyncComponent(() => import('./modules/Tools').then(({DomainsBatchComponent}) => DomainsBatchComponent)),
        'ai-answers-status': defineAsyncComponent(() => import('./page/tools/domainsBatch/AiAnswersStatus.vue')),
        'ks-tools-check-top': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsCheckTop}) => KSToolsCheckTop)),
        'ks-tools-site-themes': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsSiteThemes}) => KSToolsSiteThemes)),
        'site-themes-component': defineAsyncComponent(() => import('./modules/Tools').then(({SiteThemesComponent}) => SiteThemesComponent)),
        'ks-tools-history-serp': defineAsyncComponent(() => import('./modules/Tools').then(({KSToolsHistorySerp}) => KSToolsHistorySerp)),

        'project-dashboard': defineAsyncComponent(() => import('./modules/Projects').then(({ProjectDashboard}) => ProjectDashboard)),
        'project-create': defineAsyncComponent(() => import('./modules/Projects').then(({ProjectCreate}) => ProjectCreate)),
        'project-competitors': defineAsyncComponent(() => import('./modules/Projects').then(({ProjectCompetitors}) => ProjectCompetitors)),
        'project-dashboard-share': defineAsyncComponent(() => import('./modules/Projects').then(({ProjectDashboardShare}) => ProjectDashboardShare)),
        'project-share-links': defineAsyncComponent(() => import('./modules/Projects').then(({ProjectShareLinks}) => ProjectShareLinks)),

        'wordstat-create': defineAsyncComponent(() => import('./modules/Wordstat').then(({WordstatCreate}) => WordstatCreate)),
        'wordstat-projects-list': defineAsyncComponent(() => import('./modules/Wordstat').then(({WordstatProjectsList}) => WordstatProjectsList)),
        'wordstat-action': defineAsyncComponent(() => import('./modules/Wordstat').then(({WordstatAction}) => WordstatAction)),
        'wordstat-waiter': defineAsyncComponent(() => import('./modules/Wordstat').then(({WordstatWaiter}) => WordstatWaiter)),
        WordstatReportTitle,
        WordstatPopupWsGraph,

        'serp-create': defineAsyncComponent(() => import('./modules/Serp').then(({SerpCreate}) => SerpCreate)),
        'serp-projects-list': defineAsyncComponent(() => import('./modules/Serp').then(({SerpProjectsList}) => SerpProjectsList)),
        'serp-projects-page': defineAsyncComponent(() => import('./modules/Serp').then(({SerpProjectsPage}) => SerpProjectsPage)),
        'serp-projects-waiter': defineAsyncComponent(() => import('./modules/Serp').then(({SerpProjectsWaiter}) => SerpProjectsWaiter)),
        SerpReportTitle,

        'monitoring-popup-create': defineAsyncComponent(() => import('./modules/Monitoring').then(({MonitoringPopupCreate}) => MonitoringPopupCreate)),
        'monitoring-report-page': defineAsyncComponent(() => import('./modules/Monitoring').then(({MonitoringReportPage}) => MonitoringReportPage)),
        'monitoring-projects-list': defineAsyncComponent(() => import('./modules/Monitoring').then(({MonitoringProjectsList}) => MonitoringProjectsList)),
        'monitoring-competitors': defineAsyncComponent(() => import('./modules/Monitoring').then(({MonitoringCompetitors}) => MonitoringCompetitors)),
        'monitoring-share-links': defineAsyncComponent(() => import('./modules/Monitoring').then(({MonitoringShareLinks}) => MonitoringShareLinks)),
        'monitoring-report-page-share': defineAsyncComponent(() => import('./modules/Monitoring').then(({MonitoringReportPageShare}) => MonitoringReportPageShare)),
        'monitoring-settings-page': defineAsyncComponent(() => import('./modules/Monitoring').then(({MonitoringSettingsPage}) => MonitoringSettingsPage)),

        'ai-tracker-popup-create': defineAsyncComponent(() => import('./modules/AiTracker').then(({AiTrackerPopupCreate}) => AiTrackerPopupCreate)),
        'ai-tracker-projects-list': defineAsyncComponent(() => import('./modules/AiTracker').then(({AiTrackerProjectsList}) => AiTrackerProjectsList)),
        'ai-tracker-settings': defineAsyncComponent(() => import('./modules/AiTracker').then(({AiTrackerSettings}) => AiTrackerSettings)),
        'ai-tracker-report': defineAsyncComponent(() => import('./modules/AiTracker').then(({AiTrackerReport}) => AiTrackerReport)),
        'ai-tracker-competitors': defineAsyncComponent(() => import('./modules/AiTracker').then(({AiTrackerCompetitors}) => AiTrackerCompetitors)),
        'ai-tracker-mentions': defineAsyncComponent(() => import('./modules/AiTracker').then(({AiTrackerMentions}) => AiTrackerMentions)),
        'ai-tracker-sources': defineAsyncComponent(() => import('./modules/AiTracker').then(({AiTrackerSources}) => AiTrackerSources)),
        'ai-tracker-share-links': defineAsyncComponent(() => import('./modules/AiTracker').then(({AiTrackerShareLinks}) => AiTrackerShareLinks)),
        'ai-tracker-report-share': defineAsyncComponent(() => import('./modules/AiTracker').then(({AiTrackerReportShare}) => AiTrackerReportShare)),
        'ai-tracker-limits': defineAsyncComponent(() => import("./component/breadcrumbs/AiTrackerLimits.vue")),

        ReportBacklinks,
        ReportBacklinksDomains,
        ReportOutlinksDomains,
        ReportBacklinksIp,
        ReportBacklinksIpSubnet,
        ReportOutlinks,
        ReportBacklinksTopPages,
        ReportBacklinksAnchor,

        'ks-cluster-tour': KSClusterTour,
        'ks-report-tour': KSReportTour,

        'banner-timer': defineAsyncComponent(() => import('./component/blocks/banner/BannerTimer.vue')),
        ZenChannelAllConcurrent,
        ToolBox,
        SystemNotificationsTable,
        'ks-filter': KSFilter,
        'ks-table': KSTable,
        PositionHistoryComponent,
        RsyAdsPageAction,
        'ks-cluster-action': KSClusterAction,
        'ks-cluster-edit': KSClusterEdit,
        'ks-cluster-page-waiter': KSClusterPageWaiter,
        'ks-group-table-actions': KSGroupTableActions,
        VennComponent,
        DomainAction,
        CheckboxKeysAction,
        ConcPagesAction,
        LinksAction,
        KeywordsForOnlineWsParserAction,

        Prolong,

        // "Данные и подписка"
        'panel-account-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelAccountBlock}) => PanelAccountBlock)),
        'panel-api-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelApiBlock}) => PanelApiBlock)),
        'panel-delete-account': defineAsyncComponent(() => import('./modules/Panel').then(({PanelDeleteAccount}) => PanelDeleteAccount)),
        'panel-brand-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelBrandBlock}) => PanelBrandBlock)),
        'panel-change-password-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelChangePasswordBlock}) => PanelChangePasswordBlock)),
        'panel-restore-account-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelRestoreAccountBlock}) => PanelRestoreAccountBlock)),
        'panel-invite-request-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelInviteRequestBlock}) => PanelInviteRequestBlock)),
        'panel-corporate-users-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelCorporateUsersBlock}) => PanelCorporateUsersBlock)),
        'panel-corporate-users-share-options-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelCorporateUsersShareOptionsBlock}) => PanelCorporateUsersShareOptionsBlock)),
        'panel-promo-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelPromoBlock}) => PanelPromoBlock)),
        'panel-bills-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelBillsBlock}) => PanelBillsBlock)),
        'panel-push-notifications-block': defineAsyncComponent(() => import('./modules/Panel').then(({PanelPushNotificationsBlock}) => PanelPushNotificationsBlock)),

        ReferalCalculatorEarnings,
        PartnerHistoryEarnings,
        PartnerUserPromocode,

        // дашборд по домену
        'dashboard-domain-title': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainTitle}) => DashboardDomainTitle)),
        'dashboard-domain-ai-answers-item': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAiAnswersItem}) => DashboardDomainAiAnswersItem)),
        'dashboard-domain-ad-cost-popover': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAdCostPopover}) => DashboardDomainAdCostPopover)),
        'dashboard-domain-ai-answers': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAiAnswers}) => DashboardDomainAiAnswers)),
        'dashboard-domain-ai-answers-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAiAnswersPdf}) => DashboardDomainAiAnswersPdf)),
        'dashboard-domain-ai-concs': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAiConcs}) => DashboardDomainAiConcs)),
        'dashboard-domain-ai-concs-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAiConcsPdf}) => DashboardDomainAiConcsPdf)),
        'dashboard-domain-pages': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainPages}) => DashboardDomainPages)),
        'dashboard-domain-pages-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainPagesPdf}) => DashboardDomainPagesPdf)),
        'dashboard-domain-concs': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainConcs}) => DashboardDomainConcs)),
        'dashboard-domain-concs-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainConcsPdf}) => DashboardDomainConcsPdf)),
        'dashboard-domain-keys': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainKeys}) => DashboardDomainKeys)),
        'dashboard-domain-keys-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainKeysPdf}) => DashboardDomainKeysPdf)),
        'dashboard-domain-back-links': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainBackLinks}) => DashboardDomainBackLinks)),
        'dashboard-domain-back-links-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainBackLinksPdf}) => DashboardDomainBackLinksPdf)),
        'dashboard-domain-out-links': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainOutLinks}) => DashboardDomainOutLinks)),
        'dashboard-domain-out-links-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainOutLinksPdf}) => DashboardDomainOutLinksPdf)),
        'dashboard-domain-back-links-top-pages': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainBackLinksTopPages}) => DashboardDomainBackLinksTopPages)),
        'dashboard-domain-back-links-top-pages-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainBackLinksTopPagesPdf}) => DashboardDomainBackLinksTopPagesPdf)),
        'dashboard-domain-links-history': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainLinksHistory}) => DashboardDomainLinksHistory)),
        'dashboard-domain-rsy-ads': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainRsyAds}) => DashboardDomainRsyAds)),
        'dashboard-domain-rsy-ads-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainRsyAdsPdf}) => DashboardDomainRsyAdsPdf)),
        'dashboard-domain-ad-keys': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAdKeys}) => DashboardDomainAdKeys)),
        'dashboard-domain-ad-keys-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAdKeysPdf}) => DashboardDomainAdKeysPdf)),
        'dashboard-domain-ad-concs': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAdConcs}) => DashboardDomainAdConcs)),
        'dashboard-domain-ad-concs-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAdConcsPdf}) => DashboardDomainAdConcsPdf)),
        'dashboard-domain-ads': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAds}) => DashboardDomainAds)),
        'dashboard-domain-ads-pdf': defineAsyncComponent(() => import('./modules/DashboardDomain').then(({DashboardDomainAdsPdf}) => DashboardDomainAdsPdf)),
        // дашборд по фразе
        'dashboard-keyword-title': defineAsyncComponent(() => import('./modules/DashboardKeyword').then(({DashboardKeywordTitle}) => DashboardKeywordTitle)),
        'dashboard-keyword-wizards': defineAsyncComponent(() => import('./modules/DashboardKeyword').then(({DashboardKeywordWizards}) => DashboardKeywordWizards)),
        'dashboard-keyword-budget': defineAsyncComponent(() => import('./modules/DashboardKeyword').then(({DashboardKeywordBudget}) => DashboardKeywordBudget)),
        'dashboard-keyword-similar-keys': defineAsyncComponent(() => import('./modules/DashboardKeyword').then(({DashboardKeywordSimilarKeys}) => DashboardKeywordSimilarKeys)),
        'dashboard-keyword-ai-answers': defineAsyncComponent(() => import('./modules/DashboardKeyword').then(({DashboardKeywordAiAnswers}) => DashboardKeywordAiAnswers)),
        'dashboard-keyword-ai-answers-tops-buttons': defineAsyncComponent(() => import('./modules/DashboardKeyword').then(({DashboardKeywordAiAnswersTopsButtons}) => DashboardKeywordAiAnswersTopsButtons)),
        'dashboard-keyword-domains-tops-buttons': defineAsyncComponent(() => import('./modules/DashboardKeyword').then(({DashboardKeywordDomainsTopsButtons}) => DashboardKeywordDomainsTopsButtons)),
        'dashboard-keyword-domains-tops': defineAsyncComponent(() => import('./modules/DashboardKeyword').then(({DashboardKeywordDomainsTops}) => DashboardKeywordDomainsTops)),
        'dashboard-keyword-ads': defineAsyncComponent(() => import('./modules/DashboardKeyword').then(({DashboardKeywordAds}) => DashboardKeywordAds)),

        ZenDashboardChannelTitle,
        ZenDashboardPublications,

        HistoryQueries,
        GroupStart,
        GroupKeywords,
        ClusteringStart,
        KsCreateGroup,
        KsCreateCluster,
        ShowMore,
        AdCompanyExport,
        RuTubeEmbed,
        ScrollToTop,
        MenuTop,
        MenuTopLite,
        MenuLeft,
        AdaptersLoader,
        TariffPageQuestions,
        'check-support-feedback': defineAsyncComponent(() => import('./component/CheckSupportFeedback.vue')),
        // vue-end
        /**
         * @deprecated
         * @use AdaptersLoader
         */
        Loader,
        KsImg,
        AllRsyAdsContainer,
        'ks-select': KSSelect,

        "vuetable": Vuetable,
        "vuetable-pagination": VuetablePagination,
        "vuetable-pagination-dropdown": VuetablePaginationDropDown,
        "vuetable-pagination-info": VuetablePaginationInfo,

        TreePagesMain,
        TreeExport,
        DoughnutSites,
        "ks-create-free-project-dialog": KsCreateFreeProjectDialog,
    },
    errorCaptured(error, component, info) {
        // можно отлавливать ошибки пользователей на фронте и по API логировать для исправления на опережение
        // console.error('Global Error:', error, component, info);
    }
});

app
    .use(PrimeVue)
    .use(snotify)
    .use(store)
    .use(i18n)
    .use(VueJsTour)
    .use(upload)
    .use(router)
    .use(Vue3MobileDetection)
    .component('Popper', Popper)
    .component('RecycleScroller', RecycleScroller)
    .component('VueJsonPretty', VueJsonPretty)
    .provide('sprintf', sprintf);

// глобальные конфиги
app.config.globalProperties.$config = config;
// прод/не прод
app.config.globalProperties.$isProd =  process.env.APP_ENV === 'prod'
// глобальный обработчик событий
app.config.globalProperties.$emitter = emitter;
// Для вызовов из HTML/Twig: window.keysoEmitter.emit(window.keysoListeners.POPUP_DEMO_BLOCK_OPEN)
window.keysoEmitter = emitter;
window.keysoListeners = Listeners;

app.mount('#keysoApp');
